export const enum EmailTemplatesEnum {
  COO_BENEFICIARY_CONFIRM = 'COO_JOINTACCOUNT_CONFIRM',
  COO_EXECUTOR_CONFIRM = 'COO_EXECUTOR_CONFIRM',
  COO_UGMA_UTMA = 'COO_UGMA_UTMA',
  COO_GIFTING_CONFIRM = 'COO_GIFTING_CONFIRM',
  COO_INTERNAL_TRANSFER_CONFIRM = 'COO_NEW_INTERNAL_TRANSFER',
}
